export default {
  //代码里的key(唯一标识): '印尼语',
  lang: 'in_ID',
  appIntroduction: 'Tonton film & drama gratis populer kapan pun',
  noMoreTip: 'Sudah sampai halaman terakhir, tidak ada konten lagi',
  navigator: {
    home: 'Beranda',
    all: 'Semua konten',
    news: 'Info artikel',
    download: 'Unduh aplikasi',
    contact: 'Tentang kami',
    joinUs: 'Bergabung bersama kami'
  },
  seo: {
    title: 'LOKLOK-Nonton film HD online gratis',
    keywords: 'Loklok, Loklok app, loklok tv, Loklok official website, Loklok web,Loklok movie,Tonton Online, Tonton gratis, Tonton drama secara gratis, Film, movie, nonton, film gratis, nonton gratis, nonton film gratis, K-drama, Drama Korea, Drakor, Animasi, Anime, Film Amerika, Online, Streaming, One Piece, Singles Inferno, Harry Potter, Meteor Garden Thailand, F4 Thailand, Meteor Garden, Hotel Transylvania, Sing 2, The Kingsman, Ranking of Kings, Jujutsu Kaisen, Encanto, Attack on Titan, Squid Game, Snowdrop, Ghost Doctor, Our Beloved Summer',
    description: 'loklok-Ketegangan, komedi, thriller,film lucu,film komedi,dramaid tv',
    ogImage: 'https://static.loklok.video/img/tw-in_ID.png',
    index: {
      title: 'Loklok - Nonton film HD online gratis - Rekomendasi Film dengan Rating Tertinggi',
      keywords: 'Loklok, Loklok app, download loklok, instal loklok, unduh loklok, loklok pc, loklok apk,Tonton Online, Tonton gratis, Tonton drama secara gratis,  loklok ios, loklok android, loklok ios, loklok android tv, loklok chromecast, kdrama, drakor, drama korea, box office, film amerika, film barat, film blockbuster, one piece , naruto, hubungan cinta, all of us are dead',
      description: 'Loklok adalah platform streaming video satu atap untuk menonton film, acara TV, animasi dari seluruh dunia! Dengan berbagai macam film eksklusif, Anda dapat memilih subtitle multi-bahasa dan dalam kualitas gambar ultra-HD 4k, film baru yang populer dirilis setiap hari!'
    },
    allPage: {
      title: 'Loklok - Tonton HD Online Gratis di Seluruh Dunia, Cari Film HD Besar-besaran, Acara TV',
      keywords: 'Loklok, Loklok app, loklok download, loklok pc, loklok apk, all of us are dead,Tonton Online, Tonton gratis, Tonton drama secara gratis,  F4 Thailand: Boys Over Flowers, Euphoria Season 2, Twenty five twenty one, Forecasting Love and Weather，Ghost Doctor, True Beauty，Encanto, From，Business Proposal，Snowdrop，Rookie Cops，Still 2gether',
      description: 'Loklok memiliki sejumlah besar film dan konten televisi populer, dan serial TV dan film terbaru dan terpanas gratis untuk ditonton! Beragam konten definisi tinggi, pengalaman pengguna yang dipersonalisasi, dan film populer semuanya ada di sini.'
    },
    articles: {
      title: 'Berita Loklok - informasi film dan televisi terbaru dan terpanas, ulasan film populer, dan koleksi film terbaik global yang paling berharga, semua detail yang ingin Anda lihat tentang film Anda tersedia setiap hari!',
      keywords: 'Loklok, apk Loklok, aplikasi loklok,  loklok download, loklok pc, loklok apk,Tonton Online, Tonton gratis, Tonton drama secara gratis,  informasi film dan televisi terbaru, rekomendasi film, ulasan film populer, film dan televisi 2022, pemutaran film perdana, film terbaik 2022, film 2022 terbaik, film bioskop 2022, attack on titan final season, our beloved summer, hotel transylvania 4: transformania, happiness',
      description: 'Konten film dan drama TV populer Loklok dapat ditemukan secara instan, semua jenis film box office dan peringkat TV drama diperbarui dalam 24 jam, dan film dan serial TV populer disajikan secara real time, datang ke Loklok dan kejar film Anda.'
    },
    download: {
      title: 'Unduhan versi resmi terbaru Loklok, Google Play, App Store, unduhan apk',
      keywords: 'Loklok, Loklok app, instal loklok, loklok pc, loklok apk, loklok download, download loklok, Tonton Online, Tonton gratis, Tonton drama secara gratis, loklok download apk, loklok ios download, loklok android download, loklok googleplay, loklok pc download, loklok versi terbaru, website resmi loklok, loklok web, cara download Loklok, Loklok desktop, Loklok pad',
      description: 'Unduh versi resmi terbaru dari Aplikasi loklok Menyediakan Google Play, App Store, saluran instalasi apk'
    },
    search: {
      title: 'Loklok - Temukan Film Favorit Anda',
      keywords: 'Loklok, aplikasi Loklok, unduh loklok, loklok pc, loklok apk,Tonton Online, Tonton gratis, Tonton drama secara gratis,  cari drama, cari episode, peringkat film populer, peringkat box office, peringkat film, peringkat serial TV, peringkat film, peringkat drama korea, peringkat drama thailand',
      description: 'Loklok recomienda los dramas, películas, etc. más populares a nivel mundial de acuerdo con la popularidad de vista y búsqueda diaria en tiempo real para resolver la escasez de dramas y mejorar la experiencia de visualización.'
    },
    contact: {
      title: 'Hubungi kami melalui E-mail, Twitter, Facebook, Instagram dan Youtube. - Loklok',
      keywords: 'Twitter, Facebook, Instagram, Tonton Online, Tonton gratis, Tonton drama secara gratis, Youtube, Contact, E-mail',
      description: 'Pertanyaan tentang Loklok dapat dikomunikasikan melalui email, Twitter, Facebook, Instagram dan Youtube'
    }
  },
  globalTip: {
    emptyTip: 'Sumber daya saat ini tidak ditemukan',
    searchOther: 'Coba cari film atau serial TV lainnya'
  },
  loginModule: {
    title: 'Masuk',
    loginMethod: 'Gunakan aplikasi Loklok untuk memindai kode QR',
    loginMethodTip: '(Tingkatkan versi ke 1.7.0 atau lebih)',
    howToDownload: 'Cara unduh Loklok',
    clickMe: 'Klik di sini',
    loginSuccess: 'Berhasil masuk',
    loginFailed: 'Login gagal',
    codeExpired: 'Kode QR sudah tidak berlaku!',
    refreshButton: 'Refresh',
    loginButton: 'Masuk',
    loginTip: 'Tonton semua konten secara gratis setelah login',
    logoutButton: 'Keluar',
    logoutTip: 'Nikmati pengalaman menonton film!',
    areYouSure: 'Yakin mau keluar?',
    sure: 'Oke',
    cancel: 'Batal'
  },
  toTop: {
    downloadApp: 'Unduh aplikasi',
    backToTop: 'Kembali ke atas'
  },
  indexPage: {
    title: 'LoklokTV',
    more: 'Selengkapnya',
    seeMore: 'Lihat selengkapnya'
  },
  searchPage: {
    resultTitle: 'Hasil Pencarian:',
    rank: 'Daftar Terpopuler Loklok',
    play: 'Putar',
    popularSearch: 'Pencarian populer',
    top1: 'No. 1',
    top2: 'No. 2',
    top3: 'No. 3',
    top4: 'No. 4',
    top5: 'No. 5',
    top6: 'No. 6',
    top7: 'No. 7',
    top8: 'No. 8',
    top9: 'No. 9',
    top10: 'No. 10',
    emptyTip: 'Maaf, tidak ada konten tersebut',
    emptyDesc: 'Coba cari film atau drama lain'
  },
  filterPage: {
    emptyTip: 'Maaf, tidak ada konten tersebut',
    emptyDesc: 'Coba cari film atau drama lain'
  },
  newsPage: {
    listTitle: 'Info terkini'
  },
  downloadPage: {
    scanQR: 'Pindai kode QR untuk mengunduh aplikasi',
    title1: 'Nonton gratis kapanpun',
    tip1: 'Regardez-le à tout moment gratuitement',
    title2: 'Subtitle multi-bahasa',
    tip2: 'Drama bisa ditonton bebas',
    title3: 'Penyinkronan PC/mobile real-time'
  },
  detailPage: {
    autoTranslation: 'Terjemahan otomatis',
    fiveMiniteTip: 'Hanya 5 menit, nonton full setelah',
    loginTip2InDetailPage: 'Gunakan aplikasi Loklok untuk memindai kode QR di bawah. Tonton konten setelah berhasil login',
    category: 'Kategori',
    moreDesc: 'Selengkapnya',
    youMayLike: 'Mungkin kamu suka',
    relatedSeries: 'Seri terkait',
    norelatedSeries: 'Tidak ada seri terkait',
    emptyDesc: 'Maaf, tidak ada konten tersebut',
    emptyTip: 'Maaf, tidak ada konten tersebut',
    vip: {
      dialog: {
        t1: 'Aktifkan VIP',
        t2: 'Aktifkan VIP di aplikasi untuk menonton semua konten',
        t3: 'Unduh aplikasi melalui metode di bawah ini',
        t4: 'Sudah memiliki VIP? <span class="active">Klik disini</span> untuk login',
        t5: 'Sudah memiliki VIP? <span class="active">Refresh</span> halaman untuk lanjut menonton',
        t6: 'Anda sudah menonton {num} menit, untuk lihat versi selengkapnya silakan gunakan aplikasi atau aktifkan VIP di aplikasi untuk dapat melanjutkan menonton film ini'
      },
      player: {
        tip1: 'Hanya dapat menonton {num} menit, <span class="active">gunakan aplikasi</span> atau <span class="active">aktifkan VIP</span> untuk nonton selengkapnya'
      },
      episodes: {
        tip1: 'Beli VIP & nonton versi full'
      }
    }
  },
  playerModule: {
    NETWORK_LOADING: 'Peramban sedang mengunduh data',
    NETWORK_NO_SOURCE: 'Sumber audio/video belum ditemukan',
    MEDIA_ERR_ABORTED: 'Proses pengambilan kembali dihentikan oleh pengguna',
    MEDIA_ERR_NETWORK: 'Terjadi kesalahan saat mengunduh',
    MEDIA_ERR_DECODE: 'Analisis pemutaran gagal: tidak bisa memutar file',
    MEDIA_ERR_SRC_NOT_SUPPORTED: 'Format audio/video tidak didukung',
    REPLAY: 'Putar ulang',
    ERROR: 'Sepertinya ada masalah koneksi jaringan',
    PLAY_TIPS: 'Putar',
    PAUSE_TIPS: 'Jeda',
    PLAYNEXT_TIPS: 'Episode berikutnya',
    DOWNLOAD_TIPS: 'Unduh',
    ROTATE_TIPS: 'Putar',
    RELOAD_TIPS: 'Muat ulang',
    FULLSCREEN_TIPS: 'Buka layar penuh',
    EXITFULLSCREEN_TIPS: 'Tutup layar penuh',
    CSSFULLSCREEN_TIPS: 'Buka layar penuh',
    EXITCSSFULLSCREEN_TIPS: 'Tutup layar penuh',
    TEXTTRACK: 'Subtitle',
    PIP: 'Gambar dalam gambar',
    MINIPLAYER: 'Pemutar mini',
    SCREENSHOT: 'Jepretan layar',
    LIVE: 'Siaran langsung',
    OFF: 'Tutup',
    MINIPLAYER_DRAG: 'Ketuk dan tahan untuk geser video',
    AIRPLAY_TIPS: 'AirPlay',
    onlyPlayTip: 'Hanya bisa diputar {msg} menit, masuk untuk tonton video lengkap',
    loginTextButton: 'Masuk',
    replayButton: 'Putar ulang',
    nextButton: 'Episode berikutnya',
    refreshButton: 'Refresh',
    episode: 'Episode'
  },
  contact: {
    business: 'Mitra kerjasama',
    question: 'Kritik & saran'
  },
  download_nd: {
    desc: 'Banyak film dan drama yang bisa ditonton gratis',
    scanQR: 'Pindai kode QR untuk mengunduh aplikasi atau'
  },
  win: {
    feedback: {
      que: ' Penjelasan Pertanyaan yang Sering Diajukan',
      que1: 'Pertanyaan yang Sering Diajukan',
      content: 'Konten Umpan Balik',
      contact: 'Informasi Kontak',
      submit: 'Kirim tanggapan',
      tip1: 'Silakan berikan deskripsi yang rinci, dan Anda juga dapat menyertakan tangkapan layar yang relevan.',
      tip2: 'Silakan masukkan email Anda.',
      tip5: 'Ukuran gambar yang diunggah harus kurang dari {num}k.',
      tip6: 'Maksimal 4 gambar dapat diunggah.',
      tip3: 'Telah diajukan, harap bersabar.',
      tip4: 'Konten umpan balik harus tidak kurang dari 10 kata.',
      error: 'Kesalahan Sistem'
    }
  },
  tv: {
    vip: {
      title: 'Silakan pilih produk Anda',
      tip1: 'Anda dapat melihat kode QR pembayaran setelah masuk.',
      refresh: 'Segarkan',
      tip2: 'Pindai kode QR untuk pembayaran',
      recharge: 'Perjanjian Pengisian Ulang',
      renewal: 'Perjanjian Pembaruan',
      login: 'Masuk sekarang',
      tip3: 'Lihat setelah masuk',
      noOpen: 'VIP Standar Belum Diaktifkan',
      gift: 'Hadiah',
      succ: 'Penyegaran berhasil',
      fail: 'Penyegaran gagal',
      day: 'VIP Standar 1 Hari',
      days: 'VIP Standar {x} Hari',
      expiration: 'Waktu kedaluwarsa VIP Standar: {x}',
      expired: 'VIP Anda telah kedaluwarsa, silakan perbarui segera.',
      interests1: 'Nikmati kualitas HD 1080P',
      interests2: 'Buka semua konten',
      interests3: 'Masuk beberapa perangkat'
    }
  }
}